// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Registrazione.css - Stili per il componente Registrazione moderno */

/* Reset e variabili CSS */
:root {
  /* Colori principali */
  --primary-color: #4f46e5;
  --primary-hover: #4338ca;
  --primary-light: #e0e7ff;

  /* Colori di stato */
  --success-color: #10b981;
  --error-color: #ef4444;
  --warning-color: #f59e0b;

  /* Colori neutri */
  --white: #ffffff;
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #111827;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  /* Border radius */
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;

  /* Transitions */
  --transition-fast: 150ms ease-in-out;
  --transition-normal: 300ms ease-in-out;
  --transition-slow: 500ms ease-in-out;
}

/* Pagina di registrazione - Container principale */
.registrazione-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-attachment: fixed;
  padding: 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Container del form */
.registrazione-container {
  width: 100%;
  max-width: 400px;
  position: relative;
}

/* Card del registrazione */
.registrazione-card {
  background: var(--white);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  padding: 2rem;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.registrazione-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-color), #06b6d4, var(--success-color));
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
}

/* Header del registrazione */
.registrazione-header {
  text-align: center;
  margin-bottom: 2rem;
}

.registrazione-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.logo-icon {
  width: 3rem;
  height: 3rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-hover));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  box-shadow: var(--shadow-md);
}

.logo-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}

.registrazione-header h1 {
  font-size: 1.875rem;
  font-weight: 700;
  color: var(--gray-900);
  margin: 0;
  letter-spacing: -0.025em;
}

.registrazione-subtitle {
  color: var(--gray-600);
  font-size: 0.875rem;
  margin: 0;
  font-weight: 400;
}

/* Form styles */
.registrazione-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Form groups */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--gray-700);
  margin-bottom: 0.25rem;
}

/* Input wrapper per posizionamento icone */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

/* Stili input */
.form-control {
  width: 100%;
  padding: 0.75rem 1rem;
  padding-right: 2.5rem;
  border: 2px solid var(--gray-200);
  border-radius: var(--radius-md);
  font-size: 1rem;
  transition: all var(--transition-fast);
  background-color: var(--white);
  color: var(--gray-900);
  outline: none;
}

.form-control::placeholder {
  color: var(--gray-400);
}

/* Stati input */
.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  transform: translateY(-1px);
}

.form-control.error {
  border-color: var(--error-color);
  background-color: rgba(239, 68, 68, 0.05);
}

.form-control.error:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.form-control.success {
  border-color: var(--success-color);
  background-color: rgba(16, 185, 129, 0.05);
}

.form-control.success:focus {
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

/* Icone input */
.input-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gray-400);
  pointer-events: none;
}

.input-icon svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* Toggle password */
.password-toggle {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--gray-400);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-toggle:hover {
  color: var(--gray-600);
  background-color: var(--gray-100);
}

.password-toggle:focus {
  outline: none;
  color: var(--primary-color);
  background-color: var(--primary-light);
}

.password-toggle svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* Messaggi di errore */
.field-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--error-color);
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 0.25rem;
  animation: slideIn 0.2s ease-out;
}

.field-error svg {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

/* Opzioni form */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem 0;
}

/* Checkbox personalizzato */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--gray-600);
  -webkit-user-select: none;
          user-select: none;
}

.checkbox-label input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--gray-300);
  border-radius: var(--radius-sm);
  position: relative;
  transition: all var(--transition-fast);
  background-color: var(--white);
}

.checkbox-label input[type="checkbox"]:checked + .checkmark {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.checkbox-label input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  position: absolute;
  left: 2px;
  top: -1px;
  width: 4px;
  height: 8px;
  border: solid var(--white);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Link password dimenticata */
.forgot-password {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color var(--transition-fast);
}

.forgot-password:hover {
  color: var(--primary-hover);
  text-decoration: underline;
}

/* Pulsante registrazione */
.registrazione-button {
  width: 100%;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-hover));
  color: var(--white);
  border: none;
  border-radius: var(--radius-md);
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: var(--shadow-md);
  position: relative;
  overflow: hidden;
}

.registrazione-button:hover:not(.disabled):not(.loading) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.registrazione-button:active:not(.disabled):not(.loading) {
  transform: translateY(0);
}

.registrazione-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.registrazione-button.loading {
  cursor: wait;
  opacity: 0.8;
}

/* Spinner per loading */
.spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: var(--white);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Messaggi di feedback */
.message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: var(--radius-md);
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 1rem;
  animation: slideIn 0.3s ease-out;
}

.message svg {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.message.success {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.message.error {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--error-color);
  border: 1px solid rgba(239, 68, 68, 0.2);
}

/* Footer */
.registrazione-footer {
  text-align: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--gray-200);
}

.registrazione-footer p {
  color: var(--gray-600);
  font-size: 0.875rem;
  margin: 0;
}

.registrazione-footer a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
  transition: color var(--transition-fast);
}

.registrazione-footer a:hover {
  color: var(--primary-hover);
  text-decoration: underline;
}

/* Animazioni */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive design */
@media (max-width: 640px) {
  .registrazione-page {
    padding: 0.5rem;
  }

  .registrazione-card {
    padding: 1.5rem;
  }

  .registrazione-header h1 {
    font-size: 1.5rem;
  }

  .form-options {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
  }
}

/* Dark mode support (opzionale) */
@media (prefers-color-scheme: dark) {
  :root {
    --white: #1f2937;
    --gray-50: #111827;
    --gray-100: #1f2937;
    --gray-200: #374151;
    --gray-300: #4b5563;
    --gray-400: #6b7280;
    --gray-500: #9ca3af;
    --gray-600: #d1d5db;
    --gray-700: #e5e7eb;
    --gray-800: #f3f4f6;
    --gray-900: #ffffff;
  }

  .registrazione-page {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  }

  .registrazione-card {
    background: rgba(31, 41, 55, 0.9);
    border: 1px solid rgba(75, 85, 99, 0.3);
  }
}

/* Miglioramenti per accessibilità */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Focus visible per navigazione da tastiera */
.form-control:focus-visible,
.password-toggle:focus-visible,
.registrazione-button:focus-visible,
.checkbox-label:focus-visible,
.forgot-password:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

/* Pulsante Google OAuth e Divisore */
.google-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: #ffffff;
  color: #374151;
  border: 1.5px solid #d1d5db;
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast, 150ms);
  box-shadow: var(--shadow-sm);
  margin-bottom: 0.5rem;
}

.google-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  box-shadow: var(--shadow-md);
}

.google-btn:active {
  transform: scale(0.99);
}

.google-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.google-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.auth-divider {
  display: flex;
  align-items: center;
  margin: 1.25rem 0;
  text-align: center;
}

.auth-divider::before,
.auth-divider::after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid var(--gray-200, #e5e7eb);
}

.auth-divider span {
  padding: 0 0.75rem;
  color: var(--gray-400, #9ca3af);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/auth/Registrazione.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;;EAExB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,YAAY;EACZ,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;;EAEtF,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;;EAEjB,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,4BAA4B;EAC5B,aAAa;EACb,uFAAuF;AACzF;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uFAAuF;EACvF,oDAAoD;AACtD;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,+EAA+E;EAC/E,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,iCAAiC;IACjC,uCAAuC;EACzC;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,8CAA8C;AAC9C;;;;;EAKE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":["/* Registrazione.css - Stili per il componente Registrazione moderno */\n\n/* Reset e variabili CSS */\n:root {\n  /* Colori principali */\n  --primary-color: #4f46e5;\n  --primary-hover: #4338ca;\n  --primary-light: #e0e7ff;\n\n  /* Colori di stato */\n  --success-color: #10b981;\n  --error-color: #ef4444;\n  --warning-color: #f59e0b;\n\n  /* Colori neutri */\n  --white: #ffffff;\n  --gray-50: #f9fafb;\n  --gray-100: #f3f4f6;\n  --gray-200: #e5e7eb;\n  --gray-300: #d1d5db;\n  --gray-400: #9ca3af;\n  --gray-500: #6b7280;\n  --gray-600: #4b5563;\n  --gray-700: #374151;\n  --gray-800: #1f2937;\n  --gray-900: #111827;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\n  /* Border radius */\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n\n  /* Transitions */\n  --transition-fast: 150ms ease-in-out;\n  --transition-normal: 300ms ease-in-out;\n  --transition-slow: 500ms ease-in-out;\n}\n\n/* Pagina di registrazione - Container principale */\n.registrazione-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  background-attachment: fixed;\n  padding: 1rem;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* Container del form */\n.registrazione-container {\n  width: 100%;\n  max-width: 400px;\n  position: relative;\n}\n\n/* Card del registrazione */\n.registrazione-card {\n  background: var(--white);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  padding: 2rem;\n  position: relative;\n  overflow: hidden;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.registrazione-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--primary-color), #06b6d4, var(--success-color));\n  border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n}\n\n/* Header del registrazione */\n.registrazione-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.registrazione-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.logo-icon {\n  width: 3rem;\n  height: 3rem;\n  background: linear-gradient(135deg, var(--primary-color), var(--primary-hover));\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n  box-shadow: var(--shadow-md);\n}\n\n.logo-icon svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.registrazione-header h1 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin: 0;\n  letter-spacing: -0.025em;\n}\n\n.registrazione-subtitle {\n  color: var(--gray-600);\n  font-size: 0.875rem;\n  margin: 0;\n  font-weight: 400;\n}\n\n/* Form styles */\n.registrazione-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* Form groups */\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--gray-700);\n  margin-bottom: 0.25rem;\n}\n\n/* Input wrapper per posizionamento icone */\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n/* Stili input */\n.form-control {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  padding-right: 2.5rem;\n  border: 2px solid var(--gray-200);\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  transition: all var(--transition-fast);\n  background-color: var(--white);\n  color: var(--gray-900);\n  outline: none;\n}\n\n.form-control::placeholder {\n  color: var(--gray-400);\n}\n\n/* Stati input */\n.form-control:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  transform: translateY(-1px);\n}\n\n.form-control.error {\n  border-color: var(--error-color);\n  background-color: rgba(239, 68, 68, 0.05);\n}\n\n.form-control.error:focus {\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.form-control.success {\n  border-color: var(--success-color);\n  background-color: rgba(16, 185, 129, 0.05);\n}\n\n.form-control.success:focus {\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);\n}\n\n/* Icone input */\n.input-icon {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--gray-400);\n  pointer-events: none;\n}\n\n.input-icon svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Toggle password */\n.password-toggle {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--gray-400);\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.password-toggle:hover {\n  color: var(--gray-600);\n  background-color: var(--gray-100);\n}\n\n.password-toggle:focus {\n  outline: none;\n  color: var(--primary-color);\n  background-color: var(--primary-light);\n}\n\n.password-toggle svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Messaggi di errore */\n.field-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--error-color);\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-top: 0.25rem;\n  animation: slideIn 0.2s ease-out;\n}\n\n.field-error svg {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n}\n\n/* Opzioni form */\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0.5rem 0;\n}\n\n/* Checkbox personalizzato */\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: var(--gray-600);\n  user-select: none;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkmark {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid var(--gray-300);\n  border-radius: var(--radius-sm);\n  position: relative;\n  transition: all var(--transition-fast);\n  background-color: var(--white);\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkmark {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkmark::after {\n  content: '';\n  position: absolute;\n  left: 2px;\n  top: -1px;\n  width: 4px;\n  height: 8px;\n  border: solid var(--white);\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n/* Link password dimenticata */\n.forgot-password {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: color var(--transition-fast);\n}\n\n.forgot-password:hover {\n  color: var(--primary-hover);\n  text-decoration: underline;\n}\n\n/* Pulsante registrazione */\n.registrazione-button {\n  width: 100%;\n  background: linear-gradient(135deg, var(--primary-color), var(--primary-hover));\n  color: var(--white);\n  border: none;\n  border-radius: var(--radius-md);\n  padding: 0.875rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  box-shadow: var(--shadow-md);\n  position: relative;\n  overflow: hidden;\n}\n\n.registrazione-button:hover:not(.disabled):not(.loading) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.registrazione-button:active:not(.disabled):not(.loading) {\n  transform: translateY(0);\n}\n\n.registrazione-button.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.registrazione-button.loading {\n  cursor: wait;\n  opacity: 0.8;\n}\n\n/* Spinner per loading */\n.spinner {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: var(--white);\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Messaggi di feedback */\n.message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius-md);\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-top: 1rem;\n  animation: slideIn 0.3s ease-out;\n}\n\n.message svg {\n  width: 1.25rem;\n  height: 1.25rem;\n  flex-shrink: 0;\n}\n\n.message.success {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: var(--success-color);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.message.error {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: var(--error-color);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n}\n\n/* Footer */\n.registrazione-footer {\n  text-align: center;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--gray-200);\n}\n\n.registrazione-footer p {\n  color: var(--gray-600);\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n.registrazione-footer a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 600;\n  transition: color var(--transition-fast);\n}\n\n.registrazione-footer a:hover {\n  color: var(--primary-hover);\n  text-decoration: underline;\n}\n\n/* Animazioni */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 640px) {\n  .registrazione-page {\n    padding: 0.5rem;\n  }\n\n  .registrazione-card {\n    padding: 1.5rem;\n  }\n\n  .registrazione-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .form-options {\n    flex-direction: column;\n    gap: 0.75rem;\n    align-items: flex-start;\n  }\n}\n\n/* Dark mode support (opzionale) */\n@media (prefers-color-scheme: dark) {\n  :root {\n    --white: #1f2937;\n    --gray-50: #111827;\n    --gray-100: #1f2937;\n    --gray-200: #374151;\n    --gray-300: #4b5563;\n    --gray-400: #6b7280;\n    --gray-500: #9ca3af;\n    --gray-600: #d1d5db;\n    --gray-700: #e5e7eb;\n    --gray-800: #f3f4f6;\n    --gray-900: #ffffff;\n  }\n\n  .registrazione-page {\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n  }\n\n  .registrazione-card {\n    background: rgba(31, 41, 55, 0.9);\n    border: 1px solid rgba(75, 85, 99, 0.3);\n  }\n}\n\n/* Miglioramenti per accessibilità */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Focus visible per navigazione da tastiera */\n.form-control:focus-visible,\n.password-toggle:focus-visible,\n.registrazione-button:focus-visible,\n.checkbox-label:focus-visible,\n.forgot-password:focus-visible {\n  outline: 2px solid var(--primary-color);\n  outline-offset: 2px;\n}\n\n/* Pulsante Google OAuth e Divisore */\n.google-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background: #ffffff;\n  color: #374151;\n  border: 1.5px solid #d1d5db;\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast, 150ms);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 0.5rem;\n}\n\n.google-btn:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n  box-shadow: var(--shadow-md);\n}\n\n.google-btn:active {\n  transform: scale(0.99);\n}\n\n.google-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.google-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.auth-divider {\n  display: flex;\n  align-items: center;\n  margin: 1.25rem 0;\n  text-align: center;\n}\n\n.auth-divider::before,\n.auth-divider::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid var(--gray-200, #e5e7eb);\n}\n\n.auth-divider span {\n  padding: 0 0.75rem;\n  color: var(--gray-400, #9ca3af);\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
